import { useTracker } from '@jetshop/core/analytics/Analytics';
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
import { removeFromCart } from '@jetshop/core/data/mutations/cartMutations.gql';
import React, { useContext } from 'react';
import { Mutation } from 'react-apollo';
import { getRemoveFromCartOptimisticResponse } from './cartMutationUtils';
import { CartIdContext } from '../Cart/CartIdContext';
import throwErrorInDev from '../../helpers/throwErrorInDev';
import { unSlugify } from '@jetshop/core/analytics/integrations/unslugify';
import { breadcrumbsWithoutProduct } from '@jetshop/core/analytics/utils/breadcrumbsWithoutProduct';
const RemoveFromCart = function RemoveFromCart({ cartQuery, children }) {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to RemoveFromCart`);
    const { cartId, setCartId } = useContext(CartIdContext);
    const track = useTracker();
    return (React.createElement(Mutation, { onCompleted: (data) => {
            if (data.removeFromCart.cart.items.length === 0) {
            }
        }, mutation: removeFromCart }, (mutate, { client }) => {
        return children((itemId, product) => {
            var _a, _b, _c;
            track(trackProductEvent({
                action: 'remove',
                product,
                category: breadcrumbsWithoutProduct((_a = product.primaryRoute) === null || _a === void 0 ? void 0 : _a.breadcrumbs) ||
                    unSlugify((_c = (_b = product.canonicalCategory) === null || _b === void 0 ? void 0 : _b.primaryRoute) === null || _c === void 0 ? void 0 : _c.path) ||
                    ''
            }));
            return mutate({
                variables: {
                    input: {
                        cartId,
                        itemId
                    }
                },
                optimisticResponse: {
                    removeFromCart: {
                        cart: getRemoveFromCartOptimisticResponse({
                            itemId,
                            client,
                            cartId,
                            setCartId,
                            cartQuery
                        }),
                        __typename: 'CartMutation'
                    }
                }
            });
        });
    }));
};
export default RemoveFromCart;
//# sourceMappingURL=RemoveFromCart.js.map